<template>
    <v-card :max-width="mobile ? '110px' : undefined" id="card" class="pa-3" elevation="0" :class="shaking?' shaking':''">
      <v-img v-if="itsChristmas()" v-bind:class="{ mobilehat: mobile }" class="hat" aspect-ratio="1" contain :max-width="mobile ? '50px' :'150px'" v-bind:src="getRandomHat()" ></v-img>
      <v-img :max-width="maxWidth" aspect-ratio="1" contain v-bind:src="getCardImage()" v-on:click="toShake">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-avatar :color="getColor()">
              <v-progress-circular indeterminate color="white"></v-progress-circular>
            </v-avatar>
          </v-row>
        </template>
      </v-img>
      <div id="card-icons" v-bind:class="{ mobileicons: mobile }">
        <v-icon :small="mobile" v-if="itsMe()" :color="getColor()">{{getMeIcon()}}</v-icon>
        <v-btn v-if="itsMe() && !isDone() && cardSelected() && !this.showCards" v-on:click="sendDone(true)" x-small fab outlined color="green" style="margin-top: 2px; margin-left: 15px">
          <v-icon dark>{{mdiCheckBold}}</v-icon>
        </v-btn>
        <v-btn v-if="isDone() && cardSelected() && !this.showCards" v-on:click="sendDone(false)" x-small fab color="green" elevation="0" style="margin-top: 2px">
          <v-icon color="white">{{mdiCheckBold}}</v-icon>
        </v-btn>
        <v-img v-if="imTheVictim()" max-width=70 v-bind:src="getReaperImage()" v-on:click="resetVictim"></v-img>
      </div>
    </v-card>
</template>

<script>
import { mdiAccount, mdiCheckBold, mdiSnowman } from '@mdi/js'

export default {
  data () {
    return {
      shaking: false,
      mdiAccount,
      mdiCheckBold,
      mdiSnowman
    }
  },
  props: {
    item: Object,
    showCards: Boolean,
    userId: Number,
    tableId: String,
    mode: String,
    maxWidth: String,
    socketId: String
  },
  sockets: {
    shake (userId) {
      if (this.item.userId === userId) {
        this.animateShaking()
      }
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    itsMe: function () {
      return this.item.userId === this.userId
    },
    imTheVictim: function() {
      return this.$store.state.reaperVictim == this.item.userId
    },
    resetVictim: function () {
      this.$socket.emit('resetVictim', this.tableId)
    },
    isDone: function () {
      return !!this.item.done
    },
    cardSelected: function () {
      return this.item.name !== "unvoted"
    },
    sendDone: function (doneValue) {
      this.$socket.emit('done', { value: doneValue, socketId: this.socketId, tableId: this.tableId })
    },
    getCardImage: function () {
      if (this.item.name === 'unvoted') {
        return this.getRandomAvatar()
      } else if (this.showCards === true || this.itsMe()) {
        return require('@/assets/cards/' + this.mode + '/' + this.item.name + '.png')
      }
      return require('@/assets/cards/cover.png')
    },
    getMeIcon: function () {
      if(this.itsChristmas())
        return mdiSnowman
      return mdiAccount
    },
    getRandomHat: function () {
      return require(`@/assets/santa-hats/hat-${(this.item.userId%3)+1}.svg`)
    },
    getRandomAvatar: function () {
      const background = this.$store.state.avatarBackground.substring(1);
      return `https://api.dicebear.com/5.x/${this.$store.state.selectedStyle}/svg?seed=${this.item.userId}&radius=50&backgroundColor=${background}`
    },
    getReaperImage: function () {
      return require('@/assets/reaper.svg');
    },
    itsChristmas: function () {
      return this.$store.state.holidaysMode === 'christmas'
    },
    startShaking: function () {
      this.shaking = true
    },
    stopShaking: function () {
      this.shaking = false
    },
    animateShaking: function () {
      this.startShaking()
      setTimeout(this.stopShaking, 300)
    },
    toShake: function () {
      this.$socket.emit('shake', { userId: this.item.userId, tableId: this.tableId })
    },
    getColor: function() {
      if(this.itsChristmas())
        return "#F44336"
      return "#4676be"
    }
  }
}
</script>

<style scoped>
#card {
  margin-left: auto; margin-right: auto;
  border-radius: 8px;
  background: transparent;
}

.shaking {
  animation: shake 0.1s infinite;
  animation-fill-mode: forwards;  
}

.hat {
  margin-top: -2em;
  margin-bottom: -3em;
  z-index: 1;
}

.mobilehat {
  margin-top: -1.5em !important;
  margin-bottom: -1em !important;
}

#card-icons {
  background-color: rgba(245, 245, 245, 0.7);
  margin-top: -10px;
  padding-top: 10px;
  width: 100px;
  height: 50px;
}

.mobileicons {
  width: 70px !important;
  height: 50px !important;
}

@keyframes shake {
    0% { transform: translateX(0); }
    25% { transform: translateX(-10px); }
    50% { transform: translateX(0); }
    75% { transform: translateX(10px); }
    100% { transform: translateX(0); }
}
</style>
